import { getIndustryDemo } from "../industryCatalog";
import { getIndustryFeatures } from "../designAssignments";

export function extractBrand(demo) {
  const p = demo?.profile ?? {};
  return p.hospital ?? p.brand ?? {};
}

export function useBrandContext(industry, demoId) {
  const demo = getIndustryDemo(industry, demoId);
  const brand = extractBrand(demo);
  const accent = demo?.accent ?? "#6d5cff";
  const features = getIndustryFeatures(industry);
  const cta =
    industry === "hospital"
      ? "예약하기"
      : industry === "bank"
        ? "상담 신청"
        : industry === "restaurant"
          ? "예약하기"
          : industry === "cafe"
            ? "메뉴 보기"
            : "문의하기";

  return {
    demo,
    brand,
    accent,
    features,
    tag: demo?.tag ?? "",
    industry,
    cta,
    url: demo?.url ?? "demo.site",
  };
}
